export default {
  methods: {
    getErrors(field, form = null) {
      let errors = form ? form.errors || {} : this.errors

      if (field in errors) {
        return errors[field]
      }

      // Each field has an array of one or more errors associated with it when performing a search.
      // For the sake of compatibility with the existing error handling, we'll return the first error.
      if (this.searchErrors && field in this.searchErrors) {
        return this.searchErrors[field][0]
      }

      return ''
    }
  }
}
